(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amys-corner-archive"]) return;
  try {
    
if (!customElements.get('mini-updates-archive')) {
customElements.define('mini-updates-archive', class extends HTMLElement {
  connectedCallback() {
    if(this.ready) return;
    this.ready = true;
    this.feed = this.querySelector('[data-update-feed]');
    this.search = this.querySelector('[data-update-search]');
    this.older = this.querySelector('[data-update-older]');
    this.status = this.querySelector('[data-update-status]');
    this.next = this.feed.dataset.next;
    this.search.addEventListener('input', () => this.update());
    this.older.addEventListener('change', () => this.update());
    this.update();
  }
  async loadArchive() {
    if(this.loading) return this.loading;
    this.loading = (async () => {
      while(this.next) {
        const url = new URL(this.next, location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url);
        if(!response.ok) throw new Error('Could not load older updates.');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = doc.querySelector('[data-update-feed]');
        if(!feed) throw new Error('Could not load older updates.');
        feed.querySelectorAll('[data-update-card]').forEach(card => this.feed.appendChild(card));
        this.next = feed.dataset.next;
      }
    })();
    try { await this.loading; } finally { this.loading = null; }
  }
  async update() {
    const query = this.search.value.trim().toLocaleLowerCase('en-GB');
    if(this.next) {
      this.status.textContent = 'Loading updates…';
      try { await this.loadArchive(); }
      catch(error) { this.render(); this.status.textContent = 'Some older updates could not load. Try searching again.'; return; }
    }
    this.render();
  }
  render() {
    const query = this.search.value.trim().toLocaleLowerCase('en-GB');
    const cutoff = Date.now() / 1000 - 30 * 86400;
    let count = 0, month = '';
    this.feed.querySelectorAll('[data-month-heading]').forEach(h => h.remove());
    this.feed.querySelectorAll('[data-update-card]').forEach(card => {
      const inRange = this.older.checked || query || Number(card.dataset.published) >= cutoff;
      const matches = !query || card.textContent.toLocaleLowerCase('en-GB').includes(query);
      card.hidden = !(inRange && matches);
      if(card.hidden) return;
      count++;
      if(card.dataset.month !== month) {
        month = card.dataset.month;
        const heading = document.createElement('h2');
        heading.className = 'mini-update-month';
        heading.dataset.monthHeading = '';
        heading.textContent = month;
        card.before(heading);
      }
    });
    this.status.textContent = count === 0 ? (query ? 'No updates match your search.' : 'No updates in the last 30 days. Select “Show older updates” to browse the archive.') : query ? count + ' matching update' + (count === 1 ? '' : 's') + ' across all months.' : this.older.checked ? 'Showing all updates, grouped by month.' : 'Showing updates from the last 30 days.';
  }
});
}

  } catch(e) { console.error(e); }
})();
})();
